import { withStyles } from '@material-ui/core';

import StatSelect from './component';
import styles from './styles';

export default withStyles(styles)(StatSelect);
